import { Component, inject, OnInit } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { CurrentUserState } from '../../../core/store/current-user/current-user.state';
import { AsyncPipe } from '@angular/common';
import { Subscription } from '../../../core/store/current-user/models/CurrentUserUIModel';
import { DashboardWelcomeComponent } from '../../../domains/academy/course/components/dashboard-welcome/dashboard-welcome.component';
import { LearningPlanService } from '../../../domains/academy/learning-plan/services/learning-plan.service';
import { LearningPlanInstancesResponseDTO } from '../../../domains/academy/learning-plan/models/LearningPlanDTO';

@Component({
  selector: 'app-dashboard-container',
  imports: [TranslocoModule, AsyncPipe, DashboardWelcomeComponent],
  templateUrl: './dashboard-container.component.html',
  styleUrl: './dashboard-container.component.css',
})
export class DashboardContainerComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly learningPlanService = inject(LearningPlanService);

  subscription$: Observable<Subscription | null> = this.store.select(
    CurrentUserState.subscription,
  );
  learningPlans$!: Observable<LearningPlanInstancesResponseDTO>;

  ngOnInit(): void {
    this.learningPlans$ = this.learningPlanService.getLearningPlanInstances();
  }
}
